<template>
    <div id="app">
    <div class="page-wrapper ice-theme sidebar-bg toggled" :class="{'sidebar-hidden': close}">
            <nav id="sidebar" :class="['sidebar-wrapper', {'nav_open': this.open, 'nav_close': this.close},]">
                <div class="sidebar-content">
                    <div class="sidebar-item sidebar-header sidebar-brand-header d-flex flex-column align-items-center justify-content-center">
                        <button class="sidebar-toggle-btn sidebar-toggle-btn-admin" @click="toggleSidebar" title="Show/Hide Sidebar">
                                <i :class="close ? 'fas fa-bars' : 'fas fa-times'"></i>
                        </button>
                        <div class="user-pic-logo">
                            <img src="@/assets/img/bxb.png" alt="BXB Logo" />
                        </div>
                        <h5 class="brand-title">{{ user.name }} {{ user.is_master_agent === true ? '- Master' : '- Agent' }}</h5>
                        <!-- <div v-if="user">
                            <div class="user-info mt-2 text-center">
                                <div class="user-name" style="color:#fff;font-weight:600;">{{ user.name }}</div>
                            </div>
                        </div> -->
                    </div>
                    <div class=" sidebar-item sidebar-menu" v-if="user.is_master_agent === true">
                        <ul>
                            <div class="divider">Main Menu</div>
                            <li  style="margin-top: 12px;">
                                <router-link :class="[{active: url === 'dashboard'}]" to="/dashboard">
                                    <i class="fas fa-tachometer-alt i-font"></i>
                                    <span class="menu-text">Dashboard</span>
                                </router-link>
                            </li>
                            <!-- <li  style="margin-top: 12px;">
                                <router-link :class="[{active: url === 'dashboard'}]" to="/dashboard">
                                    <i class="fas fa-cog i-font"></i>
                                    <span class="menu-text">Setting</span>
                                </router-link>
                            </li> -->
                            <li >
                            <div class="divider">Account Manage</div>
                                <router-link :class="[{active: url === 'agent-list' || url === 'agent-create' || url === 'agent-edit'}]" :to="{ name: 'agent-list', query: { 
                                            page: 1, 
                                            orderBy: 'desc', 
                                            sortKey: 'created_at',
                                            name: '',
                                            email: ''
                                            }}">
                                    <i class="fas fa-users i-font"></i>
                                    <span class="menu-text">Agent</span>
                                </router-link>
                                <router-link :class="[{active: url === 'member-list' || url === 'member-create' || url === 'member-edit'}]" :to="{ name: 'member-list', query: { 
                                            page: 1, 
                                            orderBy: 'desc', 
                                            sortKey: 'created_at',
                                            name: '',
                                            email: ''
                                            }}">
                                    <i class="fas fa-users i-font"></i>
                                    <span class="menu-text">Member</span>
                                </router-link>
                            </li>
                            <div class="divider">Report Manage</div>
                            <li >
                                <router-link :class="[{active: url === 'daily-report-list' || url === 'daily-report-create' || url === 'daily-report-edit'}]" :to="{ name: 'daily-report-list', query: { 
                                            page: 1, 
                                            orderBy: 'desc', 
                                            sortKey: 'created_at',
                                            name: ''
                                            }}">
                                    <i class="fas fa-receipt i-font"></i>
                                    <span class="menu-text">Daily</span>
                                </router-link>
                                <router-link :class="[{active: url === 'agent-report-list' || url === 'agent-report-create' || url === 'agent-report-edit'}]" :to="{ name: 'agent-report-list', query: { 
                                            page: 1, 
                                            orderBy: 'desc', 
                                            sortKey: 'created_at',
                                            name: ''
                                            }}">
                                    <i class="fas fa-receipt i-font"></i>
                                    <span class="menu-text">Agent Report</span>
                                </router-link>
                                <router-link :class="[{active: url === 'member-report-list' || url === 'member-report-create' || url === 'member-report-edit'}]" :to="{ name: 'member-report-list', query: { 
                                            page: 1, 
                                            orderBy: 'desc', 
                                            sortKey: 'created_at',
                                            name: ''
                                            }}">
                                    <i class="fas fa-receipt i-font"></i>
                                    <span class="menu-text">Member Report</span>
                                </router-link>
                            </li>
                            <div class="divider">Payment Manage</div>
                            <li >
                                <router-link :class="[{active: url === 'deposit-list' || url === 'deposit-create' || url === 'deposit-edit'}]" :to="{ name: 'deposit-list', query: { 
                                            page: 1, 
                                            orderBy: 'desc', 
                                            sortKey: 'created_at',
                                            name: ''
                                            }}">
                                    <i class="fas fa-money-bill-wave i-font"></i>
                                    <span class="menu-text">Deposit</span>
                                </router-link>
                                <router-link :class="[{active: url === 'withdraw-list' || url === 'withdraw-create' || url === 'withdraw-edit'}]" :to="{ name: 'withdraw-list', query: { 
                                            page: 1, 
                                            orderBy: 'desc', 
                                            sortKey: 'created_at',
                                            name: ''
                                            }}">
                                    <i class="fas fa-paper-plane i-font"></i>
                                    <span class="menu-text">Withdraw</span>
                                </router-link>
                                <router-link :class="[{active: url === 'bank-list' || url === 'bank-create' || url === 'bank-edit'}]" :to="{ name: 'bank-list', query: { 
                                            page: 1, 
                                            orderBy: 'desc', 
                                            sortKey: 'created_at',
                                            name: ''
                                            }}">
                                    <i class="fas fa-bank i-font"></i>
                                    <span class="menu-text">Bank Info</span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class=" sidebar-item sidebar-menu" v-if="user.is_master_agent === false">
                        <ul>
                            <div class="divider">Main Menu</div>
                            <li  style="margin-top: 12px;">
                                <router-link :class="[{active: url === 'agent-dashboard'}]" to="/agent-dashboard">
                                    <i class="fas fa-tachometer-alt i-font"></i>
                                    <span class="menu-text">Dashboard</span>
                                </router-link>
                            </li>
                            <li >
                            <div class="divider">Account Manage</div>
                                <router-link :class="[{active: url === 'agent-member-list' || url === 'agent-member-create' || url === 'agent-member-edit'}]" :to="{ name: 'agent-member-list', query: { 
                                            page: 1, 
                                            orderBy: 'desc', 
                                            sortKey: 'created_at',
                                            name: '',
                                            email: ''
                                            }}">
                                    <i class="fas fa-users i-font"></i>
                                    <span class="menu-text">Member</span>
                                </router-link>
                            </li>
                            <div class="divider">Report Manage</div>
                            <li >
                                <router-link :class="[{active: url === 'agent-daily-report-list' || url === 'agent-daily-report-create' || url === 'agent-daily-report-edit'}]" :to="{ name: 'agent-daily-report-list', query: { 
                                            page: 1, 
                                            orderBy: 'desc', 
                                            sortKey: 'created_at',
                                            name: ''
                                            }}">
                                    <i class="fas fa-receipt i-font"></i>
                                    <span class="menu-text">Daily</span>
                                </router-link>
                                <router-link :class="[{active: url === 'agent-member-report-list' || url === 'agent-member-report-create' || url === 'agent-member-report-edit'}]" :to="{ name: 'agent-member-report-list', query: { 
                                            page: 1, 
                                            orderBy: 'desc', 
                                            sortKey: 'created_at',
                                            name: ''
                                            }}">
                                    <i class="fas fa-receipt i-font"></i>
                                    <span class="menu-text">Member Report</span>
                                </router-link>
                            </li>
                            <div class="divider">Payment Manage</div>
                            <li  style="margin-top: 12px;">
                                <router-link :class="[{active: url === 'agent-request-withdraw-list'}]" to="/agent-request-withdraw-list">
                                    <i class="fas fa-paper-plane i-font"></i>
                                    <span class="menu-text">Withdraw</span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <!-- sidebar-menu  -->
                </div>
                <!-- sidebar-footer  -->
                <div class="sidebar-footer">
                    <!-- <div>
                        <a href="#" @click="logout()">
                            <i class="fa fa-power-off"></i>
                        </a>
                    </div>
                    <div class="pinned-footer">
                        <a href="#">
                            <i class="fas fa-ellipsis-h"></i>
                        </a>
                    </div> -->
                </div>
            </nav>
            <div class="layer" @click="closeNav()" :class="{'layer_open': overlay}"></div>
            <!-- page-content  -->
            <main class="page-content">
                    <AppHeader 
                        :sidebarOpen="!close"
                        @toggle-menu="openNav" 
                        @toggle-sidebar="toggleSidebar"
                        @dollar-click="onDollarClick">
                    </AppHeader>
                    <router-view :class="routerViewClass"/>
            </main>
        </div>

    </div>
</template>
<script>
    import {
        mapActions
    } from 'vuex'
    import AppHeader from '@/components/AppHeader.vue'
    export default {
        name: 'admin',
        data() {
            return {
                routerViewClass: 'my-custom-class',
                saleCount: '',
                transferCount: '',
                productCount: '',
                check: true,
                close: false, // sidebar visible by default
                open: true,
                overlay: false, // controls the layer overlay
                name: '',
                role: '',
                url: '',
                permissions: "",
                user: null,
                dropdowns: {
                    hymn: false,
                    bible: false,
                    notification: false,
                    event: false
                }
            }
        },
        components: {
            AppHeader
        },
        methods: {
            toggleSidebar() {
                // Only toggle sidebar, not overlay
                this.open = !this.open;
                this.close = !this.close;
            },
            onDollarClick() {
                // TODO: Implement dollar button action
                alert('Dollar button clicked!');
            },
            ...mapActions({
            }),
            openNav: function () {
                // Open sidebar and show overlay (for mobile/menu)
                this.open = true;
                this.close = false;
                this.overlay = true;
            },
            closeNav: function () {
                // Hide sidebar and overlay
                this.open = false;
                this.close = true;
                this.overlay = false;
            },
            toggleDropdown(dropdown) {
                this.dropdowns[dropdown] = !this.dropdowns[dropdown];
            },
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            },
            logout() {
                window.localStorage.removeItem('token');
                window.localStorage.removeItem('user');
                window.localStorage.removeItem('church');
                this.$router.replace('/login');
            },
            defaultMenu(){

            }
        },
        watch: {
               '$route'(to, from) {
                this.url = to.name
               }
        },
        mounted() {
            this.url = this.$route.name
            // Get user info from localStorage
            const userStr = window.localStorage.getItem('user');
            if (userStr) {
                try {
                    this.user = JSON.parse(userStr);
                } catch (e) {
                    this.user = null;
                }
            }
        }
    }
</script>
<style lang="scss">
    @import "https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css";
    @import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css";
    @import "../assets/css/main.css";
    @import "../assets/css/sidebar-themes.css";
    @import "../assets/css/datepicker.scss";
    @import "~vue-multiselect/dist/vue-multiselect.min.css";

    .page-wrapper.sidebar-hidden {
        margin-left: 0 !important;
    }
    .sidebar-hidden .page-content {
        width: 100vw !important;
        max-width: 100vw !important;
        left: 0 !important;
        margin: 0 !important;
        padding-left: 0 !important;
        transition: width 0.3s, max-width 0.3s, left 0.3s, margin 0.3s, padding 0.3s;
    }
    .sidebar-hidden .main-header {
        width: 100vw !important;
        max-width: 100vw !important;
        left: 0 !important;
        margin: 0 !important;
        padding-left: 0 !important;
        transition: width 0.3s, max-width 0.3s, left 0.3s, margin 0.3s, padding 0.3s;
    }
    /* Fallback for nav_open/nav_close if not present in your main CSS */
    .nav_open {
        left: 0 !important;
        transition: left 0.3s;
    }
    .nav_close {
        left: -280px !important;
        transition: left 0.3s;
    }
    .divider {
        display: flex;
        align-items: center;
        text-align: center;
        color: #fff;
        font-weight: 600;
        font-size: 15px;
        letter-spacing: 1px;
        margin: 18px 0 10px 0;
        padding: 0 0 0 0;
        position: relative;
        background: linear-gradient(90deg, #2B3A42 0%, #4F8A8B 100%);
        border-radius: 8px;
        height: 36px;
        box-shadow: 0 2px 8px rgba(44, 62, 80, 0.08);
        justify-content: center;
    }
    .divider::before, .divider::after {
        content: '';
        flex: 1;
        height: 2px;
        background: linear-gradient(90deg, #4F8A8B 0%, #fff 100%);
        margin: 0 12px;
        border-radius: 2px;
        opacity: 0.5;
    }
    .divider::before {
        margin-left: 18px;
    }
    .divider::after {
        margin-right: 18px;
    }

    .sidebar-brand-header {
        background: linear-gradient(90deg, #2B3A42 0%, #4F8A8B 100%);
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        padding: 24px 0 12px 0;
        margin-bottom: 8px;
        box-shadow: 0 2px 8px rgba(44, 62, 80, 0.08);
    }
    .user-pic-logo {
        width: 64px;
        height: 64px;
        background: #bedbff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 8px rgba(44, 62, 80, 0.10);
        margin-bottom: 8px;
    }
    .user-pic-logo img {
        width: 48px;
        height: 48px;
        object-fit: contain;
        border-radius: 50%;
    }
    .user-pic-logo {
        flex-direction: row;
        gap: 8px;
        position: relative;
    }
    .sidebar-toggle-btn-admin {
        border: none;
        color: #4F8A8B;
        width: 38px;
        height: 38px;
        display: none;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        box-shadow: 0 2px 8px rgba(44, 62, 80, 0.10);
        font-size: 1.2rem;
        cursor: pointer;
        transition: background 0.2s, color 0.2s;
        outline: none;
        position: absolute;
        top: 0px;
        right: 0px;
        // background: #fff;
        // border-radius: 50%;
        z-index: 1002;
    }

    @media (max-width: 991.98px) {
        .sidebar-toggle-btn-admin {
            display: flex;
        }
    }
    .sidebar-toggle-btn-admin:hover {
        background: #4F8A8B;
        color: #fff;
    }
    .sidebar-wrapper {
        border-right: 2px solid #bedbff;
        box-shadow: 2px 0 8px rgba(44, 62, 80, 0.08);
    }
    .brand-title {
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        letter-spacing: 2px;
        margin: 0;
        text-align: center;
        text-shadow: 0 2px 8px rgba(44, 62, 80, 0.10);
    }

    .my-custom-class {
        width: 90%;
    }

    .back-btn {
		background: #fff;
		border: none;
        color: #4F8A8B;
		border-radius: 50%;
		width: 38px;
		height: 38px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		margin-right: 12px;
		box-shadow: 0 2px 8px rgba(44, 62, 80, 0.10);
		font-size: 1.2rem;
		cursor: pointer;
		transition: background 0.2s, color 0.2s;
		outline: none;
	}
	.back-btn:hover {
        background: #4F8A8B;
		color: #fff;
	}

    //Table

    .common-table {
        background: #fff;
        border-radius: 8px;
        border: 1px solid #bedbff;
        width: 100%;
        margin-bottom: 0;
        border-collapse: collapse;
    }
    .common-table thead {
        background: #bedbff;
    }
    .common-table th, .common-table td {
        vertical-align: middle;
        border-bottom: 1px solid #bedbff;
        padding: 14px 16px;
        font-size: 1rem;
    }
    .common-table th {
        font-weight: 700;
        letter-spacing: 0.5px;
        text-align: left;
        color: #fff;
        background: #4e8889;
    }
    .common-table tbody tr {
        transition: background 0.2s;
    }
    .common-table tbody tr:hover {
        background: #e6f0ff;
    }
    .common-table .btn-option {
        background: transparent;
        border: 1px solid #bedbff;
        border-radius: 6px;
        width: 32px;
        height: 32px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 1rem;
        margin-right: 4px;
        color: #4F8A8B;
        transition: background 0.2s, color 0.2s, border 0.2s;
    }
    .common-table .btn-action {
        background: transparent;
        border: 1px solid #bedbff;
        border-radius: 6px;
        // width: 32px;
        // height: 32px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 1rem;
        margin-right: 4px;
        color: #4F8A8B;
        transition: background 0.2s, color 0.2s, border 0.2s;
    }
    .common-table .btn-option:hover {
        background: #bedbff;
        color: #222;
        border-color: #bedbff;
    }
    .common-table .text-danger.btn-option:hover {
        background: #e74c3c;
        color: #fff;
        border-color: #e74c3c;
    }
    .common-table .text-primary.btn-option:hover {
        background: #3498db;
        color: #fff;
        border-color: #3498db;
    }
    .common-table th:last-child, .common-table td:last-child {
        text-align: right;
    }
    .table-pagination-minimal {
        margin-top: 18px;
        width: 100%;
    }
    .table-pagination-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        gap: 12px;
    }
    .table-info-minimal.left-align {
        margin-bottom: 0;
        margin-right: auto;
    }
    .table-info-minimal {
        color: #222;
        font-size: 1rem;
        margin-bottom: 0.5rem;
        font-weight: 500;
        background: #f8faff;
        border-radius: 6px;
        padding: 4px 16px;
        border: 1px solid #e3eafc;
        box-shadow: 0 1px 4px 0 rgba(190,219,255,0.07);
    }
    .table-info-minimal span {
        color: #4F8A8B;
        font-weight: 700;
        margin: 0 2px;
    }
    .pagination-minimal {
        display: flex;
        align-items: center;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 1px 4px 0 rgba(190,219,255,0.07);
        padding: 4px 12px;
        border: 1px solid #e3eafc;
    }
    .pagination-minimal ul {
        display: flex;
        list-style: none;
        padding: 0;
        margin: 0;
        gap: 4px;
    }
    .pagination-minimal li {
        border-radius: 5px;
        overflow: hidden;
    }
    .pagination-minimal button {
        min-width: 32px;
        min-height: 32px;
        padding: 0 10px;
        border: none;
        background: #f8faff;
        color: #4F8A8B;
        font-size: 1rem;
        font-weight: 500;
        border-radius: 5px;
        transition: background 0.18s, color 0.18s, box-shadow 0.18s;
        cursor: pointer;
        outline: none;
        box-shadow: none;
    }
    .pagination-minimal li.active button {
        background: #bedbff;
        color: #232946;
        font-weight: 700;
        box-shadow: 0 2px 8px 0 rgba(190,219,255,0.12);
    }
    .pagination-minimal li.disabled button {
        background: #f0f2f7;
        color: #b0b0b0;
        cursor: not-allowed;
        pointer-events: none;
    }
    .pagination-minimal button:hover:not(:disabled) {
        background: #e6f0ff;
        color: #232946;
    }
    .b-calendar-inner {
        width: 350px !important;
    }
    // Make card full width on tablet and mobile
    .agent-member-card-responsive {
        width: 100%;
    }
    @media (max-width: 991.98px) {
        .agent-member-card-responsive {
            width: 100vw;
            left: 50%;
            right: 50%;
            margin-left: -50vw;
            margin-right: -50vw;
            border-radius: 0;
        }
    }
    // Table Border
    table, th, td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }
    .agent-color {
        background-color: #41f80946 !important;
    }
    .member-color {
        background-color: #0d47e93a !important;
    }
</style>